import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { typography } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';

// const footerBottomBarBackground = '#333333';

// const scrollShadowBaseCss = {
//   content: '""',
//   backgroundImage:
//     'linear-gradient(to right, rgb(57,57,57) 22%, rgba(57, 57, 57, 0.3))',
//   width: 30,
//   height: '100%',
//   position: 'absolute',
//   top: 0,
//   opacity: 0,
//   pointerEvents: 'none',
//   transition: 'opacity 0.1s',
// };
export const sectionTitle = css({
  color: 'red',
  h2: {
    color: '#393939',
    fontSize: '40PX',
    lineHeight: '56px',
    fontWeight: '500',
    letterSpacing: '-0.3px',
    marginBottom: 32,
    marginTop: 32,
  },

  [MediaQueries.lgAndUp]: {
    h2: {
      color: '#393939',
      fontSize: '48PX',
      lineHeight: '48px',
      fontWeight: '500',
      letterSpacing: '-0.1px',
      marginBottom: 40,
      marginTop: 40,
    },
  },
});

export const goBackButtonContainer = css({
  marginBottom: 48,
});

export const goBackButton = css(typography.effra16, {
  border: 0,
  background: colorsPalette.transparent,
  color: colorsPalette.black,
  display: 'flex',
  alignItems: 'center',
  padding: 0,
  cursor: 'pointer',
});

export const goBackButtonLabel = css({
  marginLeft: 10,
});

export const mainItemstop = css({
  marginBottom: 50,
});

export const mainItems = css({
  color: '#a2a2a2',
  fontSize: '14px',
  lineHeight: '1.75',
  // '.classname': { padding: '10px' },
  a: {
    color: '#393939',
    fontWeight: '600',
    textDecoration: 'none',
    display: 'block',
    fontWeight: '400',
    lineHeight: '40px',
    marginBottom: '16px',
    fontSize: '28px',
    letterSpacing: '-0.4px',
  },
});

export const itemHolder = css({
  marginBottom: 50,
});

export const underline = css({
  borderBottom: '1px solid #D9DBDD',
  marginBottom: '8px',
  display: 'inline-block',
});

export const subItems = css({
  color: '#a2a2a2',
  lineHeight: '1.75',
  a: {
    color: '',
    fontWeight: '500',
    paddingLeft: '5px',
    textDecoration: 'none',
    color: '#393939',
  },
  '.subItems': {
    paddingLeft: '15px',
    fontSize: '14px',
    a: {
      fontWeight: '400',
    },
  },
});
